<template>
  <gg-card>
    <gg-card-header>
      GreenGeeks SSL Auto-Installer
    </gg-card-header>
    <gg-card-text>
      <template>
        <div class="text-center">
          <p>{{ currentstep }}</p>
        </div>
        <div class="text-center" v-if="currentstepdetail">
          <v-col cols="12" class="text-center pt-4">
            <p>{{ currentstepdetail }}</p>
          </v-col>
        </div>
        <div class="text-center" v-if="ssl_error">
          <v-col cols="12" class="text-center pt-4">
            <strong class="error--text">{{ ssl_error }}</strong>
          </v-col>
        </div>
        <div class="text-center" v-if="canInstall">
          <gg-btn class="justify-center" @click="nextstep">Install SSL Certificate</gg-btn>
        </div>
        <v-container class="py-0 px-0" v-else>
          <v-row>
            <v-col cols="12" sm="10" offset-sm="1" v-show="showProgress">
              <v-progress-linear color="green" :value="installProgress"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SslAutoInstaller',
  props: {
    id: {
      type: [String, Number],
      required: true,
    }
  },
  data () {
    return {
      installing: false,
    }
  },
  computed: {
    ...mapGetters(['ssl_error', 'ssl', 'ssl_status']),
    canInstall () {
      return !this.installing && this.ssl_status != 'Error'
    },
    currentstep () {
      if (!this.ssl?.steps) {
        return ''
      }
      return `Step ${this.ssl.current_step} of ${this.ssl.total_steps} : ${this.ssl.steps[this.ssl.current_step].text}`
    },
    currentstepdetail () {
      const current = this.ssl?.current_step
      if (this.ssl?.steps && current && this.ssl.steps[current].desc) {
        return this.ssl.steps[current].desc
      } else {
        return false
      }
    },
    installProgress () {
      if (!this.ssl?.steps) {
        return 0
      }
      const current = this.ssl?.current_step
      const total = this.ssl?.total_steps
      if (!current || !total) {
        return 0
      }
      return Math.ceil(current / total * 100)
    },
    showProgress () {
      return this.installProgress > 0 || this.installing
    },
  },
  methods: {
    ...mapActions(['ssldostep']),
    async nextstep () {
      this.installing = true
      try {
        this.ssldostep(this.id)
      } catch (err) {
        this.reportError(err)
      }
    },
  },
  watch: {
    ssl_error () {
      if (this.ssl_error) {
        this.installing = false
      }
    },
    ssl () {
      if (this.installing && !this.ssl_error) {
        if (this.ssl.current_step <= this.ssl.total_steps) {
          this.ssldostep(this.id)
        } else {
          this.installing = false
          this.completed = true
        }
      }
    }
  }
}
</script>
